// src/auth/index.js

import router from '../router'
import {DB} from './../constants'

// URL and endpoint constants
//const API_URL = 'http://localhost/garbage/vbtest/src/php/'
const LOGIN_URL = DB + 'auth.php'
const CHECK_AUTH = DB + 'check_auth.php'
const LOGOUT = DB + 'logout.php'

export default {

  // User object will let us check authentication status
  user: {
    authenticated: false,
    id: -1,
    error: false
  },

  // Send a request to the login URL and save the returned JWT
  login (context, creds, redirect) {
    let form = new FormData()
    form.append('login', creds.login)
    form.append('password', creds.password)
    form.append('remember', creds.remember)

    fetch(LOGIN_URL, {
      method: 'post',
      body: form,
      credentials: 'include'
    })
    .then(res => res.text())
    .then(res => {
      // console.log(res, +res)
      if (!isNaN(+res)) {
        if (res !== '-1') {
          this.user.authenticated = true
          this.user.id = res
          if (redirect) {
            router.replace(redirect)
          }
        }
        else {
          context._self.error = true
        }
      }
      else {
         context._self.error_db = true
      }
      
    })
    .catch(err => {
      context.error = err
    })
  },

  // To log out, we just need to remove the token
  logout () {
    fetch(LOGOUT, {
      method: 'post',
      credentials: 'include'
    })
    .catch(err => console.log(err))
    this.user.authenticated = false
    //router.replace('/login')
  },

  checkAuth () {
    if (this.user.authenticated) {
      return true
    }
    const result = fetch(CHECK_AUTH, {
      method: 'post',
      credentials: 'include'
    })
      .then(res => res.text())
      .then(res => {
        if (!isNaN(+res)) {
          if (res !== '-1') {
            this.user.authenticated = true
            this.user.id = res
          } else {
            this.user.authenticated = false
            this.user.id = -1
          }
        } else {
          this.user.authenticated = false
          this.user.id = -1
        }
        return this.user.authenticated
      })
      .catch(err => console.log(err))
    return result
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js